import React, {useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import BrandingPage from './pages/BrandingPage';
import PricingPage from './pages/PricingPage';
import ResultsPage from './pages/ResultsPage';
import ReviewsPage from './pages/ReviewsPage';
import BusinessReviewPage from './pages/BusinessReviewPage';
import ReviewGatePage from './pages/ReviewGatePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import MarketingPage from './pages/MarketingPage';
import CWPage from './pages/CWPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import MarketingHeader from './components/marketing/MarketingHeader';
import MarketingFooter from './components/marketing/MarketingFooter';

function ScrollToTop() {
  const {pathname} = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  const {pathname} = useLocation();
  const path = pathname.replace(/\/+$/, '') || '/';
  const isMarketing = path === '/marketing';
  const isCW = path === '/cw';
  const isBranding = path === '/';
  const isReviewPage = path === '/reviews' || (!['/', '/home', '/results', '/pricing', '/marketing', '/cw', '/privacy', '/terms'].includes(path) && /^\/[^/]+(?:\/review)?$/.test(path));
  return (
    <div className="min-h-screen bg-primary-bg text-text-primary">
      {!isBranding && !isReviewPage && !isCW && (isMarketing ? <MarketingHeader /> : <Navbar />)}
      <Routes>
        <Route path="/" element={<BrandingPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/marketing" element={<MarketingPage />} />
        <Route path="/cw" element={<CWPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/:slug/review" element={<ReviewGatePage />} />
        <Route path="/:slug" element={<BusinessReviewPage />} />
      </Routes>
      {!isBranding && !isReviewPage && !isCW && (isMarketing ? <MarketingFooter /> : <Footer />)}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout />
    </Router>
  );
}